import React, { Component, Fragment } from "react";
import FooterDesktop from "../components/common/FooterDesktop";
import FooterMobile from "../components/common/FooterMobile";
import NavMenuDesktop from "../components/common/NavMenuDesktop";
import NavMenuMobile from "../components/common/NavMenuMobile";

class VideosPage extends Component {

  componentDidMount() {
    window.scroll(0, 0);
  }

  render() {
    return (
      <Fragment>

        <div className="Desktop">
          <NavMenuDesktop />
        </div>

        <div className="Mobile">
          <NavMenuMobile />
        </div>

        <div className="container text-center mt-5">

          <h2>All Videos</h2>

          <div className="row mt-4">

  <div className="col-md-6 mb-4">
   <iframe width="560" height="315" src="https://www.youtube.com/embed/RmfcGoXvMXc?si=eKPGvzTsEYdghpMW" 
   title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; 
   picture-in-picture; web-share" 
   referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
  </div>

  <div className="col-md-6 mb-4">
    <iframe width="560" height="315" 
    src="https://www.youtube.com/embed/vRm-B9vG0Nw?si=-Lbc_Ztwf0C_sc5e" title="YouTube video player" 
    frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; 
    picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
        
    </iframe>
  </div>

</div>

        </div>

        <div className="Desktop">
          <FooterDesktop />
        </div>

        <div className="Mobile">
          <FooterMobile />
        </div>

      </Fragment>
    );
  }
}

export default VideosPage;